<template>
  <el-dialog
    class="snooker-room-dialog"
    :title="`${preTitle}桌球室`"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="cancel"
    width="520px"
  >
    <!--  目前的限制都是按照ui设计时 一个校区只能存在一个桌球室的去做出的数量限制，如果以后允许创建多个桌球室则可以去掉限制   -->
    <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
      <el-form-item label="校区" prop="campusId">
        <el-radio-group v-model="formData.campusId" disabled>
          <el-radio-button v-for="{campusName, id} in campusList" :key="id" :label="id">{{ campusName }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="桌球室名" prop="name">
        <el-input v-model.trim="formData.name" />
      </el-form-item>
      <el-form-item label="状态" prop="enable">
        <el-switch
          v-model="formData.enable"
          active-color="var(--color-success)"
          :active-value="1"
          active-text="启用"
          inactive-text="禁用"
          :inactive-value="0"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <cancel-popover ref="cancelRef" :disabled.sync="loadData.loading" :update-flag="updateFlag" />
      <el-button type="primary" @click="save('桌球室',saveSnookerRoomApi)">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import { getSnookerRoomByIdApi, saveSnookerRoomApi } from '@/api/student-manage/snooker-room-api.js'

export default {
  name: 'SnookerRoomDialog',
  mixins: [dialog],
  props: {
    campusId: {
      type: String
    }
  },
  data() {
    return {
      campusList: [], // 校区list
      formData: {
        id: '',
        campusId: '',
        enable: 1,
        name: '',
        remarks: ''
      },
      rules: {
        campusId: {
          required: true,
          message: '请选择',
          trigger: 'blur'
        },
        name: [{
          required: true,
          message: '请输入桌球室名',
          trigger: 'blur'
        },
          this.$store.state.commonValidate.limit30WordsObj]
      }
    }
  },
  mounted() {
    this.getCampusList()
    this.$nextTick(async () => {
      if (this.id) {
        await this.getDataById(this.id, getSnookerRoomByIdApi)
      } else if (this.campusId) {
        this.formData.campusId = this.campusId
      }
    })
  },
  methods: {
    saveSnookerRoomApi,
    // 获取校区
    async getCampusList() {
      try {
        const res = await this.$http.getCampusListQuery({})
        this.campusList = res.data
      } catch (e) {
      }
    }
  }
}
</script>
<style lang="scss">
.snooker-room-dialog {
  .table-item {
    align-items: center;

    .el-switch {
      &:before {
        content: attr(--text);
      }
    }
  }
}
</style>
